import
  React
from 'react';

import {
  useHistory,
  useLocation
} from 'react-router-dom';

import {
  Image,
  Text,
  VContainer,
  VFillContainer
} from '@vodacom/web-common';

import {
  Environment
} from '@vodacom/web-env';

import {
  DrupalProvider
} from 'providers';

import {
  Accordion,
  BackButton
} from 'components';

import {
  CustomColors
} from '../constants';

import {
  HandleRender,
  withScreenViewTagging
} from 'hocs';

import {
  isEqual
} from 'helpers';

const FAQUI = () => {

  const [
    state,
    setState
  ] = React.useState({
    faqPage: null,
    loading: true,
    error: null,
    openAccordionIndex: -1
  });

  const history = useHistory();
  const location = useLocation();
  const mountedRef = React.useRef(true);

  const urlParams = new URLSearchParams(location?.search);
  const faqPage = urlParams.get('faqPage');

  const getFaqPages = async () => {

    if (!mountedRef.current) {
      return;
    }

    const faqPages = await DrupalProvider.getCachedItem('faq_pages', null, DrupalProvider.getFaqPages);

    if (!faqPages || !faqPages.ok) {

      setState(prevState => ({
        ...prevState,
        loading: false,
        error: faqPages?.error || true
      }));
      return;
    }

    setState(prevState => ({
      ...prevState,
      faqPage: faqPages?.result?.find(page => page.title === faqPage) || faqPages?.result?.find(page => isEqual(page.title, 'General FAQs')),
      loading: false
    }));
  };

  React.useEffect(() => {

    mountedRef.current = true;

    const init = async () => {
      await getFaqPages();
    };

    init();

    return () => {
      mountedRef.current = false;
    };

  }, [ faqPage ]);

  const expandAccordion = index => {

    setState(prevState => ({
      ...prevState,
      openAccordionIndex: (index !== prevState.openAccordionIndex) ? index : -1
    }));
  };

  const buildAccordionList = () => {

    let accordionList = [];

    if (!state.faqPage.faqs.length > 0) {

      return accordionList;
    }

    for (const [ index, faqItem ] of state.faqPage.faqs.entries()) {

      if (!faqItem.header || !faqItem.content) {
        continue;
      }

      let header =
        <Text
          color={CustomColors.Grey9}
          fontSize={'16px'}
          fontWeight={'bold'}
          padding={'0 15px 0 0'}>

          {faqItem.header}
        </Text>
      ;

      let content =
        <Text
          padding={'0 18px'}
          color={CustomColors.Grey9}
          fontSize={'16px'}
          dangerouslySetInnerHTML={{ __html: faqItem.content }}/>
      ;

      accordionList.push(

        <Accordion
          padding={'24px 18px 20px 16px'}
          key={`faq-item-${faqItem.header}`}
          header={header}
          content={content}
          isOpen={index === state.openAccordionIndex}
          onAccordionClick={() => expandAccordion(index)}/>
      );
    }

    return accordionList;
  };

  return (

    <VFillContainer>

      <HandleRender
        isLoading={state.loading}
        isError={state.error}>

        {
          state.faqPage &&
          <VContainer
            padding={'0 0 16px'}>

            <VContainer>

              { state.faqPage.headerImage &&
                <Image
                  width={'100%'}
                  height={'auto'}
                  src={`${Environment.current.drupalBaseUrl}${state.faqPage.headerImage}`} />
              }
            </VContainer>

            <BackButton
              onClick={() => history.goBack()}/>

            <Text
              color={CustomColors.Grey11}
              fontSize={'20px'}
              fontWeight={'bold'}
              padding={'8px 18px 16px'}>

              {state.faqPage.header}
            </Text>

            {buildAccordionList()}

          </VContainer>
        }
      </HandleRender>
    </VFillContainer>
  );
};

export const FAQ = withScreenViewTagging(FAQUI);